import { map } from 'rxjs/operators';

import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { Capacitor } from '@capacitor/core';
import { ApiService } from '@core/services';
import { IonSelect, Platform } from '@ionic/angular';

import { AuthService } from '../services/auth.service';
import { DataService } from '../services/data.service';
import { HelpService } from '../services/help.service';

@Component({
  selector: 'app-initial',
  templateUrl: './initial.page.html',
  styleUrls: ['./initial.page.scss'],
})
export class InitialPage implements OnInit {
  #apiService: ApiService = inject(ApiService);
  show = false;
  @ViewChild('mySelect') selectRef: IonSelect;
  mitec$ = this.#apiService.get('saml2/mitec').pipe(map((res) => (Capacitor.isNativePlatform() ? res : false)));

  constructor(
    private auth: AuthService,
    private platform: Platform,
    private dataService: DataService,
    private router: Router,
    private screenOrientation: ScreenOrientation,
    private helpService: HelpService
  ) {}

  ngOnInit() {
    this.auth.checkRedirectFromServer().then(() => {
      setTimeout(() => {
        this.show = true;
      }, 500);
    });
  }

  ionViewDidEnter() {
    this.platform.ready().then(() => {
      if (this.platform.is('cordova')) {
        // set to landscape
        this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
      }
    });
  }

  preregister() {
    this.selectRef.open();
  }

  goPreregister(campus) {
    this.dataService.setData('registerCampus', campus);
    this.router.navigate(['/preregister', {}]);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InitialPage');
  }

  help() {
    this.helpService.presentActionSheet();
  }
}
